import angular = require("angular");

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { AllMaterialModule } from "../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";
import {
    activitiesState,
    dayState,
    dayWithParamsState,
    searchActivitiesState,
    overviewState,
    overviewWithParamsState,
    workSchedulesState,
    workScheduleState,
    editWorkScheduleState,
    newWorkScheduleState,
    workScheduleMustersState,
    clearActivitiesState,
    clearActivitiesWithParamsState,
    timeBalanceMailState,
    activityAdjustmentsState,
    activityAdjustmentsWithParamsState,
    newActivityAdjustmentState,
    editActivityAdjustmentState
} from "./activities.states";
import { SearchActivitiesComponent } from "./search-activities.component";

import { ConfirmDialog } from "../shared/confirm-dialog.component";

import { WorkSchedulesComponent } from "./work-schedules.component";
import { WorkScheduleComponent } from "./work-schedule.component";
import { EditWorkScheduleComponent } from "./work-schedule.edit.component";
import { WorkScheduleSteps } from "./work-schedule-steps.component";

import { WorkScheduleMustersComponent } from "./work-schedule-musters.component";

import SharedModule from "../shared/shared.module";
import { CoreModule } from "../core/core.module";
import { ComponentsModule } from "../components/components.installer";
import { MatDatepickerModule } from "@angular/material";

import { MaterialTimeControlModule } from "angular-material-time-control";
import { DayActitiesComponent } from "./daily-activities/day-activities.component";
import { ServicesModule } from "../services/services.module";
import { WorkplaceSelectorComponent } from "./daily-activities/workplace-selector.component";
import { ActivitySelectorComponent } from "./daily-activities/activity-selector.component";
import { PersonSelectorComponent } from "./daily-activities/person-selector.component";
import { ActivityOverviewComponent } from "./daily-activities/activity-overview.component";
import { FilterByWorkplaceIdPipe, FilterByWorkgroupPipe } from "./daily-activities/activity-filter-by.pipes";
import { ActivityTypesDisplayComponent } from "./daily-activities/activity-types-display.component";
import { ClearActivities } from "./clear-activities.component";
import { ActivitiesSharedModule } from "./shared/activities-shared.module";
import { ActivityOverviewModule } from "./overview/activity-overview.module";
import { TimeBalanceMailComponent } from "./time-balance-mail.component";
import { ActivityAdjustmentsModule } from "./adjustments/activity-adjustments.module";

export function initialize() {
    angular.module("app.activities", [
        "ui.router", "ui.router.upgrade"
    ]);
}

let STATES = [
    activitiesState,
    dayState,
    dayWithParamsState,
    searchActivitiesState,
    overviewState,
    overviewWithParamsState,
    workSchedulesState,
    workScheduleState,
    editWorkScheduleState,
    newWorkScheduleState,
    workScheduleMustersState,
    clearActivitiesState,
    clearActivitiesWithParamsState,
    timeBalanceMailState,
    activityAdjustmentsState,
    activityAdjustmentsWithParamsState,
    newActivityAdjustmentState,
    editActivityAdjustmentState
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        ServicesModule,
        FlexLayoutModule,
        ComponentsModule,
        UIRouterModule.forChild({ states: STATES }),
        MatDatepickerModule,
        MaterialTimeControlModule,
        ActivitiesSharedModule,
        ActivityOverviewModule,
        ActivityAdjustmentsModule
    ],
    declarations: [
        SearchActivitiesComponent,
        DayActitiesComponent,
        WorkSchedulesComponent,
        WorkScheduleComponent,
        EditWorkScheduleComponent,
        WorkScheduleSteps,
        WorkScheduleMustersComponent,
        PersonSelectorComponent,
        WorkplaceSelectorComponent,
        ActivityOverviewComponent,
        ActivitySelectorComponent,
        ActivityTypesDisplayComponent,
        FilterByWorkplaceIdPipe,
        FilterByWorkgroupPipe,
        ClearActivities,
        TimeBalanceMailComponent
    ],
    entryComponents: [ConfirmDialog]
})
export class ActivitiesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/activities.module.ts